import React, { useEffect, useRef, useState } from "react";
import "react-grid-layout/css/styles.css";
import { useNavigate, useParams } from "react-router-dom";
import BuilderRightSideBar from "../../../../Layouts/BuilderRightSideBar";
import BuilderModal from "../../../../Layouts/Modal/BuilderModal";
import PageInfoAndActionBar from "../../../../Layouts/PageInfoAndActionBar";
import fileFolderConfig from "../../../../commonFunctions/fileFolderConfig";
import AccessTemplateSelection from "../../../../components/BuilderComponents/AccessTemplateSelection";
import CustomJS from "../../../../components/BuilderComponents/CustomJS";
import DetailsviewPreview from "../../../../components/BuilderComponents/Preview/DetailsviewPreview";
import TableTreeModal from "../../../../components/BuilderComponents/TableTreeModal";
import { useAppBlocksContext } from "../../../../context/AppBlocksContext";
import { useAuth0Context } from "../../../../context/Auth0Context";
import { useTableContext } from "../../../../context/TableContext";
import { useTreeContext } from "../../../../context/TreeDataContext";
import DetailsviewElementsBar from "./DetailsviewElementsBar";
import EditDetailsviewFields from "./EditDetailsviewFields";
import RecordsetListCardDesign from "./RecordsetListCardDesign";
import RenderNestedGridLayout from "./RenderNestedGridLayout";
import TemplateModal from "./TemplateModal";
import ButtonActionIcon from "../../../../components/BuilderComponents/ButtonActionIcon";
import NotesAndTags from "../../../../components/BuilderComponents/NotesAndTags";
import Input from "../../../../components/FormComponents/Input";
import Textarea from "../../../../components/FormComponents/Textarea";
import Button from "../../../../components/FormComponents/Button";
import MaterialIcon from "../../../../components/BuilderComponents/MaterialIcon";
import { generateObjectId } from "../../../../utils/objectIdUtils";
import { toastError, toastSuccess } from "../../../../utils/toastUtils";
import axiosInstance, { handleApiError } from "../../../../services/axiosService";

const DesktopRenderer = ({
  applicationBlockData,
  handleSaveApplicationBlock,
  handleCloneApplicationBlock,
  isForm = false
}) => {
  const {
    layout,
    setLayout,
    layoutData,
    nestedGridData,
    getDetailviewConfig,
    setApplicationBlockData,
    lockData,
    setLockData,
    selectedAppBlock
  } = useAppBlocksContext();
  const [dragFromOutside, setDragFromOutside] = useState(false);
  const [editElementRightsidebar, setEditElementRightsidebar] = useState({ show: false, id: "" });
  const { getTableTypeData } = useTableContext();
  const { blocksExplorerData } = useTreeContext();
  const tableRef = useRef({});
  const { blockId } = useParams();

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isSettingOpen, setIsSettingOpen] = useState(false);
  const [previewData, setPreviewData] = useState([]);
  const { setSelectedAppBlock } = useAppBlocksContext();
  const { user } = useAuth0Context();
  const navigate = useNavigate();
  const [allowEdit, setAllowEdit] = useState(false);

  const fetchCurrentSmData = async () => {
    try {
      const { tableObject } = await getTableTypeData(
        applicationBlockData.table_type,
        applicationBlockData.data.table_id
      );
      // await checkLock();
      tableRef.current = { ...tableObject };
    } catch (error) {
      handleApiError(error.message);
      navigate("../");
      setSelectedAppBlock({ id: "", name: "", parentData: "", table_id: "", activity_id: "" });
    }
  };

  const handleChange = (data, key) => {
    const copyBlockData = JSON.parse(JSON.stringify(applicationBlockData));
    copyBlockData[key] = data;
    setApplicationBlockData(copyBlockData);
    setIsModalOpen({ type: "" });
  };

  const handleNotesAndTag = (data, keyName) => {
    const copyBlockData = JSON.parse(JSON.stringify(applicationBlockData));
    copyBlockData[keyName] = data;
    setApplicationBlockData(copyBlockData);
  };

  const handleDragStart = (e, name, id, type) => {
    setDragFromOutside(true);
    e.dataTransfer.setData("id", id);
    e.dataTransfer.setData("type", type);
    e.dataTransfer.setData("name", name);
  };
  const editElement = (editElementData) => {
    let copyObj = layoutData.current[editElementData.i];
    const obj = {
      id: editElementData.i,
      type: copyObj.type,
      show: true,
      config: copyObj,
      elements: [applicationBlockData],
      data: editElementData.data
    };
    setEditElementRightsidebar(obj);
  };

  const handleModalAction = (response) => {
    if (response.type === "edit" || response.type === "tableview") {
      editElement(response);
    }
    if (response.type === "add" || response.type === "change" || response.type === "recordset_layout") {
      setIsModalOpen(response);
    }
  };

  const saveElement = (config) => {
    const newLayoutData = JSON.parse(JSON.stringify(layoutData.current));
    newLayoutData[config.i] = config;
    layoutData.current = newLayoutData;
    if (config.type === "html" || config.type === "dynamic-html") {
      setEditElementRightsidebar({ show: false, id: "" });
    } else {
      setLayout([...layout]);
    }
  };

  const editChangeField = (data) => {
    const nonSupportedField = ["lookup", "lookup-sm", "app-user"];
    if (nonSupportedField.includes(data.field_type)) {
      setIsModalOpen({ type: "" });
      toastError("Can not use field");
      return;
    }
    let i = isModalOpen.i;
    const newLayoutData = JSON.parse(JSON.stringify(layoutData.current));
    if (data.field_type === "recordset" || data.field_type === "recordset-list" || data.field_type === "grid") {
      data.config = {
        layouts: []
      };
    }
    const newData = { ...newLayoutData[i], ...data };
    newData.prefix = data.prefix || "";

    newLayoutData[i] = newData;
    layoutData.current = newLayoutData;
    setIsModalOpen({ type: "" });
  };

  useEffect(() => {
    if (applicationBlockData.id || isForm) {
      fetchCurrentSmData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [applicationBlockData.id, isForm]);

  useEffect(() => {
    if (layout.length === 0) {
      setAllowEdit(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (allowEdit) return;
    let detailviewConfig = getDetailviewConfig();
    detailviewConfig = detailviewConfig?.elements || [];
    setPreviewData(detailviewConfig);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [allowEdit]);

  const handletoggleLock = async () => {
    try {
      if (lockData && lockData.user_id) {
        if (lockData.user_id !== user.sub) {
          toastError("Unauthorized");
          return;
        }
        const { message } = await axiosInstance.delete(`/app/lock/${applicationBlockData.id}`);
        toastSuccess(message);
        setLockData({});
      } else {
        const userinfo = `${user.first_name} (${user.email})`;
        const lock = {
          type: "detailview",
          user_id: user.sub,
          user_info: userinfo,
          type_id: applicationBlockData.id,
          type_name: applicationBlockData.name
        };
        const { message } = await axiosInstance.post(`/app/lock`, lock);
        toastSuccess(message);
        setLockData(lock);
      }
    } catch (error) {
      handleApiError(error);
    }
  };

  const handleActivityCardInputs = (e) => {
    const { name, value, type, checked } = e.target;
    const newValue = type === "checkbox" ? checked : value;

    setApplicationBlockData({
      ...applicationBlockData,
      data: {
        ...applicationBlockData.data,
        config: {
          ...applicationBlockData.data.config,
          [name]: newValue
        }
      }
    });
  };

  const getActivityCardData = () => {
    const index = applicationBlockData.device === "desktop" ? 0 : 1;
    const activityCardData = blocksExplorerData[index]?.items.find((block) => block.name === "activitycard")?.items;
    return activityCardData || [];
  };
  const getActivityBlocksData = () => {
    const index = applicationBlockData.device === "desktop" ? 0 : 1;
    const allRecordsview = blocksExplorerData[index]?.items.find((block) => block.name === "recordsview")?.items;
    let activityRecordviews = [];
    let activityCharts = [];
    let progressBarItems = [];
    if (allRecordsview) {
      activityRecordviews = allRecordsview.filter((rv) => rv.type === "activity");
    }
    const allCharts = blocksExplorerData[index]?.items.find((block) => block.name === "chart")?.items;
    if (allCharts) {
      activityCharts = allCharts.filter((rv) => rv.type === "activity");
    }

    const allProgressbar = blocksExplorerData[index]?.items.find((block) => block.name === "progress-bar");

    if (allProgressbar) {
      progressBarItems = allProgressbar?.items || [];
    }
    return [...activityRecordviews, ...activityCharts, ...progressBarItems];
  };

  const makeVariableFolder = () => {
    if (selectedAppBlock.parentData.includes("detailsview") && blockId) {
      const allVariables = applicationBlockData.data.variables || [];
      const detailviewFolder = fileFolderConfig.getFolderConfig(
        "detailview_variables",
        "detailview variables",
        "detailview_variables",
        false,
        false,
        false
      );
      const newData = allVariables.reduce((acc, variable) => {
        detailviewFolder.items.push(
          fileFolderConfig.getFileConfig(variable.id, variable.display, "detailview_variables", false, false)
        );
        return {
          ...acc,
          [variable.id]: {
            id: variable.id,
            display: variable.display,
            type: "variable"
          }
        };
      }, {});
      return {
        tree: [detailviewFolder],
        data: newData
      };
    } else {
      return {
        tree: [],
        data: {}
      };
    }
  };

  const handleSaveRecordsetLayout = (data) => {
    const newLayoutData = JSON.parse(JSON.stringify(layoutData.current));
    newLayoutData[isModalOpen.i].config.layouts = data;
    layoutData.current = newLayoutData;
    setLayout([...layout]);
    setIsModalOpen({ type: "" });
  };

  const typeBasedSize = (type) => {
    switch (type) {
      case "button-group":
      case "detailview":
        return "large";
      case "html":
      case "dynamic-html":
        return "medium";
      default:
        return "small";
    }
  };
  return (
    <div className="detailsView_outer_body ">
      <div className="detailsView_main_section">
        {!isForm && (
          <div className="screen_save_container">
            <PageInfoAndActionBar
              pagePath={`Blocks/${applicationBlockData.data?.activity_id ? "Activity Card" : "Detailsview"}/${
                applicationBlockData.name
              }`}
              currentConfig={[layout, nestedGridData.current, layoutData.current, applicationBlockData]}
              pageName={"applicationblock"}
              savePage={handleSaveApplicationBlock}
              clonePage={handleCloneApplicationBlock}
              toggleLock={handletoggleLock}
              isLocked={lockData?.user_id || null}
              importSomething={() => setIsModalOpen({ type: "template", modal_name: "Import Template" })}
              notesPage={() => setIsModalOpen({ type: "note", modal_name: "Notes and tags" })}
              settingPage={() => setIsSettingOpen(true)}
            />
          </div>
        )}
        <div className={"desktop_draggable_field_outer"}>
          <div
            id="droppableContainerWidth"
            className={
              applicationBlockData.device === "mobile" ? "droppable_container mobile_screen" : "droppable_container"
            }
            style={{
              // borderRadius: "8px",
              width: applicationBlockData.device === "mobile" ? "50%" : "100%",
              marginTop: applicationBlockData.device === "mobile" ? "0px" : "unset"
            }}
          >
            <DetailviewHeader
              applicationBlockData={applicationBlockData}
              setEditElementRightsidebar={setEditElementRightsidebar}
              handleActivityCardInputs={handleActivityCardInputs}
              allowEdit={allowEdit}
              setAllowEdit={setAllowEdit}
            />

            {allowEdit ? (
              <RenderNestedGridLayout
                dragFromOutside={dragFromOutside}
                setDragFromOutside={setDragFromOutside}
                nestedGridData={nestedGridData}
                layoutData={layoutData}
                tableRef={tableRef}
                handleModalAction={handleModalAction}
                layout={layout}
                setLayout={setLayout}
                device={applicationBlockData.device}
                tableID={applicationBlockData.data.table_id}
              />
            ) : (
              <DetailsviewPreview detailviewConfig={previewData} />
            )}
          </div>
        </div>
      </div>

      <DetailsviewElementsBar
        handleDragStart={handleDragStart}
        device={applicationBlockData.device}
        activityCardsData={getActivityCardData()}
        activityBlocksData={getActivityBlocksData()}
      />

      <BuilderRightSideBar
        isOpen={editElementRightsidebar.show}
        onClose={() => setEditElementRightsidebar({ show: false, id: "" })}
        heading={editElementRightsidebar.type}
        size={typeBasedSize(editElementRightsidebar.type)}
      >
        {editElementRightsidebar.type === "detailview" ? (
          <DetailviewEditBar />
        ) : (
          <EditDetailsviewFields
            editElementRightsidebar={editElementRightsidebar}
            saveElement={saveElement}
            smId={applicationBlockData.data.table_id}
            tableType={applicationBlockData.table_type}
            nestedGridData={nestedGridData}
            device={applicationBlockData.device}
            appendExtraFilesAndFolders={makeVariableFolder()}
          />
        )}
      </BuilderRightSideBar>

      <BuilderModal
        isOpen={isModalOpen.type}
        onClose={() => setIsModalOpen({ type: "" })}
        modalName={isModalOpen.modal_name}
      >
        {(isModalOpen.type === "add" || isModalOpen.type === "change") && (
          <TableTreeModal
            callbackFunction={editChangeField}
            tableId={applicationBlockData.data.table_id}
            folderId={
              applicationBlockData.data?.activity_id ? [applicationBlockData.data?.activity_id, "global_fields"] : []
            }
            selectedFile={isModalOpen.type === "change" ? layoutData.current[isModalOpen.i]?.id : ""}
            appendExtraFilesAndFolders={makeVariableFolder()}
          />
        )}
        {isModalOpen.type === "recordset_layout" && (
          <RecordsetListCardDesign
            tableRef={tableRef}
            layoutData={layoutData.current[isModalOpen.i]["config"]?.layouts || []}
            handleSaveRecordsetLayout={handleSaveRecordsetLayout}
            tableId={applicationBlockData.data.table_id}
            tableType={applicationBlockData.data.table_type}
            folderId={[layoutData.current[isModalOpen.i].id]}
            device={applicationBlockData.device}
          />
        )}
        {isModalOpen.type === "note" && (
          <NotesAndTags
            notesValue={applicationBlockData.description || ""}
            tagValue={applicationBlockData.info_tag || []}
            onChange={handleNotesAndTag}
          />
        )}
        {isModalOpen.type === "owner" && (
          <AccessTemplateSelection templates={applicationBlockData.access_templates} handleChange={handleChange} />
        )}
      </BuilderModal>

      <BuilderModal
        isOpen={isModalOpen.type === "template"}
        onClose={() => setIsModalOpen({ type: "" })}
        modalName={isModalOpen.modal_name}
        // bodyStyle={{ width: "80vw" }}
      >
        {isModalOpen.type === "template" && <TemplateModal closeModal={() => setIsModalOpen({ type: "" })} />}
      </BuilderModal>

      <BuilderModal isOpen={isSettingOpen} onClose={() => setIsSettingOpen(false)} modalName="Detailview Settings">
        <DetailviewSettings
          template={applicationBlockData.access_templates}
          blockSetting={{
            show_print: applicationBlockData.detailview_settings?.show_print || false,
            size: applicationBlockData.detailview_settings?.size || "medium",
            print_custom_css: applicationBlockData.detailview_settings?.print_custom_css || ""
          }}
          handleChange={handleChange}
        />
      </BuilderModal>
    </div>
  );
};

const DetailviewHeader = ({
  applicationBlockData,
  setEditElementRightsidebar,
  handleActivityCardInputs,
  allowEdit,
  setAllowEdit
}) => {
  const { selectedAppBlock } = useAppBlocksContext();

  return (
    <>
      <div className={`detailsView_items_top ${applicationBlockData.device === "mobile" ? "mobile_style" : ""}`}>
        {selectedAppBlock.parentData.includes("detailsview") && (
          <Button
            variant="secondary"
            size="small"
            className="left_panel_button add_button"
            onClick={() => setEditElementRightsidebar({ show: true, type: "detailview" })}
          >
            + Variable
          </Button>
        )}
        {applicationBlockData.data?.activity_id && (
          <div className={`detailsView_activity_top ${applicationBlockData.device === "desktop" ? "w_50" : ""}`}>
            <div className="detailsView_activity_top_items w_100 ">
              {applicationBlockData.device === "desktop" && (
                <label className="prefilter_checkbox_label builder_label mb_0">{/* Place Holder */}</label>
              )}
              <Input
                label="Place Holder"
                type="text"
                value={applicationBlockData?.data?.config?.non_perform_activity_message}
                name="non_perform_activity_message"
                onChange={handleActivityCardInputs}
                {...(applicationBlockData.device === "mobile" ? { placeholder: "Place Holder" } : {})}
              />
            </div>
          </div>
        )}

        <div
          className="detailsView_toggle_outer"
          style={{ marginLeft: applicationBlockData.device === "mobile" ? "0px" : "" }}
        >
          {applicationBlockData.data?.activity_id && (
            <div className="detailsView_activity_top_items">
              <Input
                type="checkbox"
                name="allow_activity_history"
                checked={applicationBlockData?.data?.config?.allow_activity_history}
                onChange={handleActivityCardInputs}
              />
              <label className="prefilter_checkbox_label">Show History</label>
            </div>
          )}
          <DetailviewLayoutAction isEdit={allowEdit} onChangeEdit={() => setAllowEdit(!allowEdit)} />
        </div>
      </div>
    </>
  );
};

const DetailviewLayoutAction = ({ isEdit, onChangeEdit }) => {
  const [isExportModalOpen, setIsExportModalOpen] = useState(false);

  return (
    <div className="detailsView_activity_top_items">
      <label>Export as Template</label>
      <MaterialIcon
        name="upgrade"
        className="screen_top_icons"
        title="Export As Template"
        onClick={() => setIsExportModalOpen(true)}
      />
      <span className="edit_mode_label">Edit Mode</span>
      <div className={`toggle_switch ${isEdit ? "active" : ""}`} onClick={onChangeEdit}>
        <div className="toggle_slider"></div>
      </div>
      <BuilderModal
        isOpen={isExportModalOpen}
        onClose={() => setIsExportModalOpen(false)}
        modalName={"Export As Template"}
      >
        <ExportAsTemplateModal closeModal={() => setIsExportModalOpen(false)} />
      </BuilderModal>
    </div>
  );
};

const ExportAsTemplateModal = ({ closeModal }) => {
  const [templateName, setTemplateName] = useState("");
  const { getDetailviewConfig } = useAppBlocksContext();
  const [file, setFile] = useState(null);

  const handleSave = async () => {
    try {
      const { unique_ids, elements } = getDetailviewConfig(true);
      const image_data = await addImage();
      const payload = {
        config: {
          elements,
          unique_ids,
          image_data
        },
        name: templateName,
        type: "detailsview"
      };

      const response = await axiosInstance.post("/sysconfigs", payload);
      const { message } = response.data;
      toastSuccess(message);
      closeModal();
    } catch (error) {
      handleApiError(error);
    }
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setFile(file);
    }
  };

  const addImage = async () => {
    try {
      const formData = new FormData();
      formData.append("myFile", file);

      const uploadResponse = await axiosInstance.post(`/public/upload`, formData, {
        headers: { "Content-Type": "multipart/form-data" }
      });

      const { name, original_name, type, _id } = uploadResponse.data;
      const modifiedImage = { image_id: _id, name, original_name, type };
      setFile(null);

      return modifiedImage;
    } catch (error) {
      handleApiError(error);
    }
  };

  return (
    <div className="builder_form">
      <Input
        label="Enter Template Name"
        placeholder="Enter Template Name"
        value={templateName}
        onChange={(e) => setTemplateName(e.target.value)}
      />
      <Input label="Add Image" type="file" name="image_data" onChange={handleFileChange} />

      <Button onClick={handleSave}>Save</Button>
    </div>
  );
};

const DetailviewEditBar = () => {
  const { setApplicationBlockData, applicationBlockData } = useAppBlocksContext();

  const handleChangeVariables = (newVariables) => {
    setApplicationBlockData({
      ...applicationBlockData,
      data: {
        ...applicationBlockData.data,
        variables: newVariables
      }
    });
  };
  return (
    <div className="p_4" style={{ minWidth: "650px" }}>
      <DetailviewVariables
        variables={applicationBlockData.data.variables || []}
        onChangeVariables={handleChangeVariables}
        tableId={applicationBlockData.data.table_id}
      />
    </div>
  );
};

const DetailviewVariables = ({ variables, onChangeVariables, tableId }) => {
  const [variableName, setVariableName] = useState("");
  const [selectedVariable, setSelectedVariable] = useState(0);

  const addVariable = () => {
    const newVariableName = variableName.trim();
    if (!newVariableName) {
      return;
    }
    const variableObject = {
      display: newVariableName,
      id: generateObjectId(),
      custom_js: "",
      type: "variable"
    };
    onChangeVariables([...variables, variableObject]);
    setVariableName("");
  };

  const deleteVariable = (e, index) => {
    e.stopPropagation();
    const newVariables = [...variables];
    newVariables.splice(index, 1);
    onChangeVariables(newVariables);
    if (index === selectedVariable) {
      setSelectedVariable(0);
    }
  };

  const handleChangeInCustomJS = (value) => {
    const newVariables = [...variables];
    newVariables[selectedVariable].custom_js = value;
    onChangeVariables(newVariables);
  };
  return (
    <>
      <div className="builder_form mb_3">
        <Input
          label="Enter Variable Name"
          placeholder="Enter Variable Name"
          value={variableName}
          onChange={(e) => setVariableName(e.target.value)}
        />
        <div className="w_100">
          <Button variant="secondary" onClick={addVariable}>
            Add Variable
          </Button>
        </div>
      </div>
      <div className="detailsView_variable_outer">
        <div className="variable_block_left">
          {variables.map((variable, index) => (
            <div
              key={variable.id}
              onClick={() => setSelectedVariable(index)}
              className={`button_column_list ${index === selectedVariable ? "selected" : ""} p_3`}
            >
              <span>{variable.display}</span>
              <ButtonActionIcon type="delete" onClick={(e) => deleteVariable(e, index)} />
            </div>
          ))}
        </div>
        <div className="w_100 p_3" style={{ minWidth: "290px", height: "calc(100vh - 200px)" }}>
          {variables.length > 0 && (
            <CustomJS
              editorId={variables[selectedVariable].id}
              inputString={variables[selectedVariable].custom_js}
              handleChange={handleChangeInCustomJS}
              label="Custom JS"
              tableID={tableId}
            />
          )}
        </div>
      </div>
    </>
  );
};

const DetailviewSettings = ({ template, blockSetting, handleChange }) => {
  const [settings, setSettings] = useState({});
  useEffect(() => {
    setSettings(blockSetting);
  }, [blockSetting]);

  const handleInputChange = (event) => {
    const { type, name, value, checked } = event.target;
    const newValue = type === "checkbox" ? checked : value;

    setSettings((prevSettings) => ({
      ...prevSettings,
      [name]: newValue
    }));

    handleChange({ ...settings, [name]: newValue }, "detailview_settings");
  };

  return (
    <div className="builder_form">
      <AccessTemplateSelection templates={template} handleChange={(data) => handleChange(data, "access_templates")} />
      <div className="builder_form ">
        <label className="builder_label">Detailview Size</label>
        <div className="blocks_type_radio">
          <label className="builder_label d_flex gap_3 m_0">
            <Input
              type="radio"
              name="size"
              value="small"
              checked={settings.size === "small"}
              onChange={handleInputChange}
            />
            Small
          </label>
          <label className="builder_label d_flex gap_3 m_0">
            <Input
              type="radio"
              name="size"
              value="medium"
              checked={settings.size === "medium"}
              onChange={handleInputChange}
            />
            Medium
          </label>
          <label className="builder_label d_flex gap_3 m_0">
            <Input
              type="radio"
              name="size"
              value="large"
              checked={settings.size === "large"}
              onChange={handleInputChange}
            />
            Large
          </label>
        </div>
      </div>

      <div className="center_container ">
        <Input type="checkbox" name="show_print" checked={settings.show_print} onChange={handleInputChange} />
        <label className="builder_label mb_0">Show Print</label>
      </div>
      <div className="builder_form">
        <Textarea
          label="Print Css"
          value={settings.print_custom_css}
          name="print_custom_css"
          onChange={handleInputChange}
        />
      </div>
    </div>
  );
};

export default DesktopRenderer;
